import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import LoadingPage from "../../../Components/layouts/loading";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { SiteInspectionSchema } from "../../../Schemas/clients/client_site_inspection_schema";
import { ClientSiteInspenctionInfo } from "../../../SchemaInfo/info";
import { getId } from "../../../Components/Functions/word.fun";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { bankInfo } from "../../../SchemaInfo/bankInfo";
import { FcPanorama } from "react-icons/fc";
import CustomRadioButton from "../../../CustomComponent/custom_radio";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../../redux/user/loginReducer";
import DynamicTooltip from "../../../Components/layouts/tooltipButton";
import { BsBoxArrowInRight } from "react-icons/bs";

const EditClientSiteInspection = () => {
  const [loading, setLoading] = useState(false);
  const [clientSiteInspenctionInfo, setClientSiteInspenctionInfo] = useState(
    ClientSiteInspenctionInfo
  );
  const store = useSelector((store) => store.login.user);
  const user = useSelector((store) => store.login.user);
  const dispatch = useDispatch();
  const role = useSelector((store) => store?.login?.user?.Role);
  const [step, setStep] = useState(user?.step || 0);
  const nextStep = () => {
    setStep((prev) => prev + 1);
  };

  const prevStep = () => {
    setStep((prev) => prev - 1);
  };

  const [leadOwner, setLeadOwner] = useState();
  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => setLeadOwner(res?.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);
  const [defaultProject, setDefaultProject] = useState("");
  const [projects, setProjects] = useState([]);
  const [isDropdown, setIsDropdown] = useState("");

  const handleInputChange = (e, props) => {
    let { value } = e.target;
    if (value && value.length >= 4) {
      performRequest("GET", `/quotations/getQuotationsById/${value}`)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.error) {
              setIsDropdown("Quotations Not Found");
              props.setFieldValue("quotationNumber", "");
            } else {
              setIsDropdown(res.data.quotationNumber);
            }
          } else {
            Toast("error", "Error while getting Quotations!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
      setIsDropdown(!isDropdown);
    }
  };
  const navigate = useNavigate();
  let { id } = useParams();
  const handelSubmit = (values, isExit = "") => {
    if (step <= SiteInspectionSchema.length - 1) {
      let formData = new FormData();
      for (let key in values) {
        formData.append(key, values[key]);
      }
      const headers = { "Content-Type": "multipart/form-data" };
      performRequest(
        "PATCH",
        `/siteInspection/updateSiteInspection/${id}`,
        formData,
        headers
      )
        .then((res) => {
          if (res.status === 200) {
            if (
              isExit === "exit" ||
              (role === process.env.REACT_APP_ROLE_CLIENT
                ? step === SiteInspectionSchema.length - 2
                : step === SiteInspectionSchema.length - 1)
            ) {
              navigate("/client-site-inspection/view/" + id);
            }

            dispatch(
              loginSuccess({
                ...user,
                step: step + 1,
                submissionId: "",
              })
            );
            Toast("success", `Step : ${step + 1} filled Successfully`);
            nextStep();
          } else if (res.data.error === "Client already exists") {
            Toast("error", "Client already exists with the same email");
          } else if (res.data.message === "Project Id Is Not Found") {
            Toast("error", "Project Id Is Not Found");
          } else {
            Toast("error", "Error while updating SI!");
          }
        })
        .catch((err) => {
          if (err.response.data.message) {
            Toast("error", err.response.data.message);
          } else {
            CustomErrorResponse(err);
          }
        });
    }
  };
  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/siteInspection/getSiteInspectionById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setClientSiteInspenctionInfo({
            ...res.data?.additionDetails,
            ...res.data?.clientDetails,
            ...res.data?.climate,
            ...res.data?.dimensions,
            ...res.data?.facilities,
            ...res.data?.land,
            ...res.data?.newSiteInspection,
            quotationNumber: res.data?.quotationNumber,
            aifQuotationNumber: res.data?.aifQuotationNumber,
            salesRelationshipManager: res.data?.salesRelationshipManager,
            siNumber: res.data?.siNumber,
            ...res.data?.sunlight,
            ...res.data?.water,
            lookingForGovernmentSupport:
              res.data?.lookingForGovernmentSupport ||
              ClientSiteInspenctionInfo.lookingForGovernmentSupport,
            projectOwnerGender:
              res.data?.projectOwnerGender ||
              ClientSiteInspenctionInfo.projectOwnerGender,
            location: res.data?.location || ClientSiteInspenctionInfo.location,
            cast: res.data?.cast || ClientSiteInspenctionInfo.cast,
            borrowFromBank:
              res.data?.borrowFromBank ||
              ClientSiteInspenctionInfo.borrowFromBank,
            appliedForAIFDPR:
              res.data?.appliedForAIFDPR ||
              ClientSiteInspenctionInfo.appliedForAIFDPR,
            tenure: res.data?.tenure || ClientSiteInspenctionInfo.tenure,
            rateOfInt:
              res.data?.rateOfInt || ClientSiteInspenctionInfo.rateOfInt,
            fundingAmmountType:
              res.data?.fundingAmmountType == "true"
                ? true
                : ClientSiteInspenctionInfo.fundingAmmountType,
          });
        } else {
          Toast("error", "Error while getting SI!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
        navigate("/");
      })
      .finally(() => setLoading(false));
  }, [id, projects, step]);

  useEffect(() => {
    if (role === process.env.REACT_APP_ROLE_CLIENT) {
      performRequest("GET", "/siteInspection/getAllProjects")
        .then((res) => {
          setProjects(res.data);
          const matchingProject = res?.data?.find(
            (project) => project?.clientEmail === store.Email
          );
          if (matchingProject) {
            const projectId = getId(matchingProject?.cpNumber);
            setDefaultProject(matchingProject?.clientName);
          }
        })
        .catch((err) => CustomErrorResponse(err));
    }
  }, [store.Email, role]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <style>{`
        .custom-stepper {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
}

.custom-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.custom-step-circle {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid gray;
}

.custom-step-circle.active {
  background-color: green;
  color: white;
  border-color: green;
}

        `}</style>
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">
                  <FcPanorama className="fs-2 me-1" />
                  Site Inspection
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card mb-1">
            <ul
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 8px",
                position: "relative",
                listStyle: "none",
              }}
            >
              {SiteInspectionSchema?.map((li, index) => {
                if (
                  index === SiteInspectionSchema.length - 1 &&
                  role === process.env.REACT_APP_ROLE_CLIENT
                ) {
                  return null;
                }

                const isActive = index === step;

                return (
                  <li
                    key={index}
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => setStep(index)}
                  >
                    {/* Line before (skip for first step) */}
                    {index !== 0 && (
                      <div
                        style={{
                          position: "absolute",
                          top: "12px",
                          left: "-50%",
                          width: "100%",
                          height: "2px",
                          backgroundColor: "#ccc",
                          zIndex: 0,
                        }}
                      />
                    )}

                    {/* Step circle */}
                    <div
                      style={{
                        zIndex: 1,
                        width: "21px",
                        height: "21px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontWeight: "bold",
                        backgroundColor: isActive ? "#22c55e" : "#fff",
                        color: isActive ? "#fff" : "#555",
                        border: `2px solid ${isActive ? "#22c55e" : "#ccc"}`,
                      }}
                    >
                      {index + 1}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="card">
            <Formik
              initialValues={clientSiteInspenctionInfo}
              validationSchema={SiteInspectionSchema[step]}
              enableReinitialize
              onSubmit={handelSubmit}
            >
              {(props) => (
                <Form>
                  {step === 0 && (
                    <>
                      <h2 className="m-0 p-2">Promoter Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Promoter Details:</h3>
                              To prepare an accurate and investment-ready DPR
                              (Detailed Project Report), Kryzen Biotech requires
                              specific technical, financial, and personal
                              details from the client. These details directly
                              influence subsidy eligibility, bank viability,
                              civil requirements, ROI calculations, and the
                              exact farm design.
                            </p>

                            <ul>
                              <li>
                                <b>Name:</b> Enter your full name as per Aadhar
                                Card / Pan Card.
                              </li>
                              <li>
                                {" "}
                                <b>Date of Birth:</b> Enter your date of birth
                                as per Aadhar card / Pan Card.
                              </li>
                              <li>
                                {" "}
                                <b>Highest Qualification:</b> This is required
                                to check your eligibility of PMEGPY / CMEGPY
                                (Employment generation program subsidy) Current
                                Profession (This will help us identify and
                                suggest tax saving bracket you can go for.)
                              </li>
                              <li>
                                {" "}
                                <b>Experience With Farming:</b> This will help
                                us to identify kind of support and handholding
                                you will require to succeed in the Hydroponic
                                Venture.
                              </li>
                              <li>
                                {" "}
                                <b>Cast:</b> This will help us identify your
                                eligibility for Various NHM and NHB schemes.
                              </li>
                              <li>
                                {" "}
                                <b>Cast:</b>This will help us identify your
                                eligibility for Various NHM and NHB schemes.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          {role === process.env.REACT_APP_ROLE_CLIENT &&
                            defaultProject && (
                              <>
                                <div className="mb-3 row d-none">
                                  <label className="form-label col-lg-3">
                                    Project
                                  </label>
                                  <div className="col-lg-9 position-relative">
                                    {defaultProject}
                                  </div>
                                </div>

                                <div className="mb-3 row d-none">
                                  <label className="form-label col-lg-3">
                                    Inspection date
                                  </label>
                                  <div className="col-lg-9 position-relative">
                                    <CustomInput
                                      name="inspectionDate"
                                      type="date"
                                    />
                                    {/* <DynamicTooltip
                                      label={
                                        "This input is used to select a date of inspection"
                                      }
                                    /> */}

                                    {props.touched.inspectionDate &&
                                      props.errors.inspectionDate && (
                                        <p className="text-danger">
                                          {props.errors.inspectionDate}
                                        </p>
                                      )}
                                  </div>
                                </div>
                                <div className="mb-3 row d-none">
                                  <label className="form-label col-lg-3 required">
                                    Sales relationship manager
                                  </label>
                                  <div className="col-lg-9 d-none required ">
                                    <CustomSelect name="salesRelationshipManager">
                                      <option value="">Select project</option>
                                      {leadOwner &&
                                        leadOwner?.map((pro, index) => {
                                          return (
                                            <option
                                              key={index}
                                              value={pro.userName}
                                            >
                                              {pro.userName}
                                            </option>
                                          );
                                        })}
                                    </CustomSelect>
                                    {/* <DynamicTooltip
                                      label={
                                        "This input is used to select a sales relationship manager"
                                      }
                                    /> */}

                                    {props.touched.salesRelationshipManager &&
                                      props.errors.salesRelationshipManager && (
                                        <p className="text-danger">
                                          {
                                            props.errors
                                              .salesRelationshipManager
                                          }
                                        </p>
                                      )}
                                  </div>
                                </div>
                              </>
                            )}
                          {role !== process.env.REACT_APP_ROLE_CLIENT && (
                            <>
                              <div className="mb-3 row">
                                <label className="form-label col-lg-3 required ">
                                  Project
                                </label>

                                <div className="col-lg-9 position-relative">
                                  <CustomSelect name="projectId" type="number">
                                    <option value="">Select project</option>
                                    {projects?.map((pro) => (
                                      <option
                                        key={pro.cpNumber}
                                        value={getId(pro.cpNumber)}
                                      >
                                        {pro.clientName}
                                      </option>
                                    ))}
                                  </CustomSelect>

                                  {/* <DynamicTooltip
                                    label={
                                      "This input is used to select a project"
                                    }
                                  /> */}

                                  {props.touched.projectId &&
                                    props.errors.projectId && (
                                      <p className="text-danger">
                                        {props.errors.projectId}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="form-label col-lg-3">
                                  Inspection date
                                </label>
                                <div className="col-lg-9 position-relative">
                                  <CustomInput
                                    name="inspectionDate"
                                    type="date"
                                  />
                                  {/* <DynamicTooltip
                                    label={
                                      "This input is used to select a date of inspection"
                                    }
                                  /> */}
                                  {props.touched.inspectionDate &&
                                    props.errors.inspectionDate && (
                                      <p className="text-danger">
                                        {props.errors.inspectionDate}
                                      </p>
                                    )}
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <label className="form-label col-lg-3 required">
                                  Sales relationship manager
                                </label>
                                <div className="col-lg-9 position-relative">
                                  <CustomSelect name="salesRelationshipManager">
                                    <option value="">
                                      Select relationship manager
                                    </option>
                                    {leadOwner &&
                                      leadOwner?.map((pro, index) => {
                                        return (
                                          <option
                                            key={index}
                                            value={pro.userName}
                                          >
                                            {pro.userName}
                                          </option>
                                        );
                                      })}
                                  </CustomSelect>
                                  {/* <DynamicTooltip
                                    label={
                                      "This input is used to select a sales relationship manager"
                                    }
                                  /> */}
                                  {props.touched.salesRelationshipManager &&
                                    props.errors.salesRelationshipManager && (
                                      <p className="text-danger">
                                        {props.errors.salesRelationshipManager}
                                      </p>
                                    )}
                                </div>
                              </div>
                            </>
                          )}

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">Name</label>
                            <div className="col-lg-9 position-relative">
                              {" "}
                              <CustomInput
                                name="name"
                                type="text"
                                placeholder="Enter Name as per Aadhar Card"
                              />
                              {/* <DynamicTooltip
                                label={
                                  "Enter the full name of the promoter as per Aadhar Card"
                                }
                              /> */}
                              {props.touched.name && props.errors.name && (
                                <p className="text-danger">
                                  {props.errors.name}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Date of Birth
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput name="dateOfBirth" type="date" />
                              {/* <DynamicTooltip
                                label={
                                  "This input is used to select the date of birth of the promoter"
                                }
                              /> */}
                              {props.touched.dateOfBirth &&
                                props.errors.dateOfBirth && (
                                  <p className="text-danger">
                                    {props.errors.dateOfBirth}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Highest Qualification
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                name="highestQualification"
                                type="text"
                              >
                                <option value="">Select Education</option>
                                <option value="No Formal Education">
                                  No Formal Education
                                </option>
                                <option value="Primary Education">
                                  Primary Education
                                </option>
                                <option value="Secondary Education">
                                  Secondary Education
                                </option>
                                <option value="High School Diploma">
                                  High School Diploma
                                </option>
                                <option value="GED or Equivalent">
                                  GED or Equivalent
                                </option>
                                <option value="Vocational/Technical Certificate">
                                  Vocational/Technical Certificate
                                </option>
                                <option value="Apprenticeship">
                                  Apprenticeship
                                </option>
                                <option value="Associate of Arts">
                                  Associate of Arts (AA)
                                </option>
                                <option value="Associate of Science">
                                  Associate of Science (AS)
                                </option>
                                <option value="Associate of Applied Science">
                                  Associate of Applied Science (AAS)
                                </option>
                                <option value="Bachelor of Arts">
                                  Bachelor of Arts (BA)
                                </option>
                                <option value="Bachelor of Science">
                                  Bachelor of Science (BS)
                                </option>
                                <option value="Bachelor of Computer Application">
                                  Bachelor of Computer Application (BCA)
                                </option>
                                <option value="Bachelor of Business Administration">
                                  Bachelor of Business Administration (BBA)
                                </option>
                                <option value="Bachelor of Engineering">
                                  Bachelor of Engineering (BE/BEng)
                                </option>
                                <option value="Bachelor of Technology">
                                  Bachelor of Technology (B.Tech)
                                </option>
                                <option value="Master of Arts">
                                  Master of Arts (MA)
                                </option>
                                <option value="Master of Science">
                                  Master of Science (MS)
                                </option>
                                <option value="Master of Business Administration">
                                  Master of Business Administration (MBA)
                                </option>
                                <option value="Master of Education">
                                  Master of Education (MEd)
                                </option>
                                <option value="Doctor of Philosophy">
                                  Doctor of Philosophy (PhD)
                                </option>
                                <option value="Doctor of Medicine">
                                  Doctor of Medicine (MD)
                                </option>
                                <option value="Doctor of Dental Surgery">
                                  Doctor of Dental Surgery (DDS)
                                </option>
                                <option value="Doctor of Nursing Practice">
                                  Doctor of Nursing Practice (DNP)
                                </option>
                                <option value="Juris Doctor">
                                  Juris Doctor (JD)
                                </option>
                                <option value="Doctor of Pharmacy">
                                  Doctor of Pharmacy (PharmD)
                                </option>
                                <option value="Doctor of Veterinary Medicine">
                                  Doctor of Veterinary Medicine (DVM)
                                </option>
                                <option value="Other">Other</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select the highest qualification attained by the promoter, such as "Bachelor of Science" or "Master of Business Administration".'
                                }
                              /> */}
                              {props.touched.highestQualification &&
                                props.errors.highestQualification && (
                                  <p className="text-danger">
                                    {props.errors.highestQualification}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Current Profession
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                type="text"
                                name="currentProfession"
                              >
                                <option value="">select </option>
                                <option value="business">Business</option>
                                <option value="working">Working</option>
                                <option value="freelancing">Freelancing</option>
                                <option value="retired">Retired</option>
                                <option value="freeher">Freeher</option>
                                <option value="other">other</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select promoters current profession like "bussiness", "working", etc.'
                                }
                              /> */}
                              {props.touched.currentProfession &&
                                props.errors.currentProfession && (
                                  <p className="text-danger">
                                    {props.errors.currentProfession}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Experience With Farming
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                type="text"
                                name="experienceWithFarming"
                              >
                                <option value="">select </option>
                                <option value="basic">Basic</option>
                                <option value="intermediate">
                                  Intermediate
                                </option>
                                <option value="expert">Expert</option>
                                <option value="ancestral know-hows">
                                  Ancestral know-hows
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select the level of experience the promoter has with farming, such as "Basic", "Intermediate", "Expert", or "Ancestral know-hows".'
                                }
                              /> */}
                              {props.touched.experienceWithFarming &&
                                props.errors.experienceWithFarming && (
                                  <p className="text-danger">
                                    {props.errors.experienceWithFarming}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">Cast</label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect type="text" name="cast">
                                <option value="">Select </option>
                                <option value="open/general">
                                  Open/General
                                </option>
                                <option value="scheduled cast">
                                  Scheduled Cast (SC)
                                </option>
                                <option value="scheduled tribes">
                                  Scheduled Tribes (ST)
                                </option>
                                <option value="other backward classes">
                                  Other Backward Classes (OBC)
                                </option>
                                <option value="minorities">Minorities</option>
                                <option value="vimukta jati">
                                  Vimukta Jati (VJ)
                                </option>
                                <option value="vimukta jati">
                                  Nomadic Tribes (NT)
                                </option>
                                <option value="special backward class">
                                  Special Backward Class (SBC)
                                </option>
                                <option value="protected tribes">
                                  Protected Tribes
                                </option>
                                <option value="other">Other</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select the caste category of the promoter, such as "Open/General", "Scheduled Cast (SC)", "Scheduled Tribes (ST)", etc.'
                                }
                              /> */}
                              {props.touched.cast && props.errors.cast && (
                                <p className="text-danger">
                                  {props.errors.cast}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Gender
                            </label>

                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                type="text"
                                name="projectOwnerGender"
                              >
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="prefer not to mention">
                                  Prefer not to mention
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={"select the gender of the promoter"}
                              /> */}
                              {props.touched.projectOwnerGender &&
                                props.errors.projectOwnerGender && (
                                  <p className="text-danger">
                                    {props.errors.projectOwnerGender}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 1 && (
                    <>
                      <h2 className="m-0 p-2">Site Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Site Details:</h3>
                              This will help us identify exactly where we are
                              planning to setup our project. Application Type:
                              This will help you to get the benefits of GST as
                              well as Tax exemptions. (If you apply as an
                              individual for the project. Your income from this
                              venture will be considered as agricultural income,
                              and you don't have to pay tax on it.) We strongly
                              suggest doing this as an individual
                            </p>

                            <ul>
                              <li>
                                <b>Site Address:</b> Mention exact Site address
                                as per Postal system.
                              </li>
                              <li>
                                {" "}
                                <b> Location Identification:</b> This will help
                                us to check the eligibility of agricultural
                                subsidy availability for the region you are
                                planning to construct the hydroponic project.
                              </li>
                              <li>
                                {" "}
                                <b>Latitude & Longitude::</b> This gives exact
                                pin point location of site. This can be derived
                                easily from google maps.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Application Type
                            </label>
                            <div className="col-lg-9 position-relative">
                              <div className="d-flex gap-3">
                                <CustomRadioButton
                                  type="radio"
                                  name="applicationType"
                                  value="individual"
                                />
                                <label>Individual</label>

                                <CustomRadioButton
                                  type="radio"
                                  name="applicationType"
                                  value="business"
                                />
                                <label>Business</label>
                              </div>
                              {/* <DynamicTooltip
                                label={
                                  "choose the type of application being made"
                                }
                              /> */}
                              {props.touched.aadharcardNumber &&
                                props.errors.aadharcardNumber && (
                                  <p className="text-danger">
                                    {props.errors.aadharcardNumber}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-1 row">
                            <label className="form-label col-lg-3">
                              Site Address
                            </label>
                            <div className="col-lg-9 position-relative">
                              {" "}
                              <CustomInput
                                name="siteAddressLine1"
                                type="text"
                                placeholder="Address line 1"
                              />
                              {/* <DynamicTooltip
                                label={
                                  "Enter the primary address line for the site location."
                                }
                              /> */}
                              {props.touched.siteAddressLine1 &&
                                props.errors.siteAddressLine1 && (
                                  <p className="text-danger">
                                    {props.errors.siteAddressLine1}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3"></label>
                            <div className="col-lg-9 position-relative">
                              {" "}
                              <CustomInput
                                name="siteAddressLine2"
                                type="text"
                                placeholder="Address line 2"
                                className="my-1 form-control"
                              />
                              {/* <DynamicTooltip
                                label={
                                  "If available, Enter the secondary address line for the site location."
                                }
                              /> */}
                              {props.touched.siteAddressLine2 &&
                                props.errors.siteAddressLine2 && (
                                  <p className="text-danger">
                                    {props.errors.siteAddressLine2}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">City</label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput type="text" name="city" />
                              {/* <DynamicTooltip
                                label={
                                  "Enter the city where the site is located"
                                }
                              /> */}
                              {props.touched.city && props.errors.city && (
                                <p className="text-danger">
                                  {props.errors.city}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">State</label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput type="text" name="state" />
                              {/* <DynamicTooltip
                                label={
                                  "Enter the state where the site is located"
                                }
                              /> */}
                              {props.touched.state && props.errors.state && (
                                <p className="text-danger">
                                  {props.errors.state}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Pincode
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput type="number" name="sitePinCode" />
                              {/* <DynamicTooltip
                                label={
                                  "Enter the pincode for the area where the site is located"
                                }
                              /> */}
                              {props.touched.sitePinCode &&
                                props.errors.sitePinCode && (
                                  <p className="text-danger">
                                    {props.errors.sitePinCode}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              How will you identify this site location?
                            </label>
                            <div className="col-lg-9 position-relative">
                              <div className="d-flex flex-wrap gap-3">
                                {[
                                  { value: "farmland", label: "Farmland" },
                                  { value: "village", label: "Village" },
                                  { value: "district", label: "District" },
                                  { value: "city", label: "City" },
                                ].map(({ value, label }) => (
                                  <label
                                    key={value}
                                    className="d-flex align-items-center gap-2"
                                  >
                                    <CustomRadioButton
                                      type="radio"
                                      name="identitfyLocation"
                                      value={value}
                                    />
                                    {label}
                                  </label>
                                ))}
                              </div>
                              {/* <DynamicTooltip
                                label={
                                  "choose how you will identify the site location"
                                }
                              /> */}

                              {props.touched.identitfyLocation &&
                                props.errors.identitfyLocation && (
                                  <p className="text-danger">
                                    {props.errors.identitfyLocation}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Location Identification
                            </label>
                            <div className="col-lg-9 position-relative">
                              <div className="d-flex flex-wrap gap-3">
                                {[
                                  { value: "rural", label: "Rural" },
                                  { value: "semi-urban", label: "Semi Urban" },
                                  { value: "district", label: "District" },
                                  { value: "urban", label: "Urban" },
                                ].map(({ value, label }) => (
                                  <label
                                    key={value}
                                    className="d-flex align-items-center gap-2"
                                  >
                                    <CustomRadioButton
                                      type="radio"
                                      name="locationIdentification"
                                      value={value}
                                    />
                                    {label}
                                  </label>
                                ))}
                              </div>
                              {/* <DynamicTooltip
                                label={
                                  "choose the location identification type for the site"
                                }
                              /> */}
                              {props.touched.locationIdentification &&
                                props.errors.locationIdentification && (
                                  <p className="text-danger">
                                    {props.errors.locationIdentification}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Type of Site
                            </label>

                            <div className="col-lg-9 position-relative">
                              <CustomSelect type="text" name="typeOfSite">
                                <option value="">select </option>
                                <option value="farmLand">Farm Land</option>
                                <option value="naPlot">NA Plot</option>
                                <option value="indoor">Indoor</option>
                                <option value="underConstructionSite">
                                  Under Construction Site
                                </option>
                                <option value="commercialSite">
                                  Commercial Site
                                </option>
                                <option value="governmentPlot">
                                  Government Plot
                                </option>
                                <option value="other">Other</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  "select the type of site for the inspection from the available options"
                                }
                              /> */}
                              {props.touched.typeOfSite &&
                                props.errors.typeOfSite && (
                                  <p className="text-danger">
                                    {props.errors.typeOfSite}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Latitude & Longitude
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                type="text"
                                name="googleMapsLocationLink"
                                placeholder="Ex: 18.5463722,54.384699"
                              />
                              <p className="text-warning">
                                Latitude & Longitude must be in the format:
                                18.5463722,54.384699
                              </p>
                              {/* <DynamicTooltip
                                label={
                                  "Enter the latitude and longitude coordinates of the site location in the format: 18.5463722,54.384699"
                                }
                              /> */}
                              {props.touched.googleMapsLocationLink &&
                                props.errors.googleMapsLocationLink && (
                                  <p className="text-danger">
                                    {props.errors.googleMapsLocationLink}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 2 && (
                    <>
                      <h2 className="m-0 p-2">Manangement Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Manangement Details:</h3>
                              This gives us idea for material planning and
                              co-ordination.
                            </p>

                            <ul>
                              <li>
                                <b>Tentative Start Date:</b> This helps us to
                                adjust the metal and market pricing in DPR. So
                                you get better and longer validity on the DPR.
                              </li>
                              <li>
                                {" "}
                                <b>Site Manage:</b> This will help us to speak
                                to someone if anything changes in DPR, so we can
                                collect realtime information on site.
                              </li>
                              <li>
                                {" "}
                                <b>No. of Staff:</b> This will help us calculate
                                if there is any pre-salary you are paying to
                                staff who are going to manage the project. This
                                cost will get added to DPR.
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Tentative Start Date
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                type="date"
                                name="tentativeStartDate"
                              />
                              {/* <DynamicTooltip
                                label={
                                  "This input is used to select the tentative start date for site management"
                                }
                              /> */}
                              {props.touched.tentativeStartDate &&
                                props.errors.tentativeStartDate && (
                                  <p className="text-danger">
                                    {props.errors.tentativeStartDate}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Site Manager Appointed
                            </label>

                            <div className="col-lg-9 position-relative">
                              <div className="d-flex gap-3">
                                <CustomRadioButton
                                  type="radio"
                                  name="siteManagerAppointed"
                                  value="yes"
                                />
                                <label>Yes </label>
                                <CustomRadioButton
                                  type="radio"
                                  name="siteManagerAppointed"
                                  value="no"
                                />
                                <label>No </label>
                              </div>
                              {/* <DynamicTooltip
                                label={
                                  "choose whether a site manager has been appointed for the site"
                                }
                              /> */}
                              {props.touched.locationIdentification &&
                                props.errors.locationIdentification && (
                                  <p className="text-danger">
                                    {props.errors.locationIdentification}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Site Manager Name
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput type="text" name="siteManagerName" />
                              {/* <DynamicTooltip
                                label={
                                  "If available, Enter the full name of the site manager appointed for overseeing site operations."
                                }
                              /> */}
                              {props.touched.siteManagerName &&
                                props.errors.siteManagerName && (
                                  <p className="text-danger">
                                    {props.errors.siteManagerName}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Site Manager Phone
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                type="text"
                                name="siteManagerPhone"
                              />
                              {/* <DynamicTooltip
                                label={
                                  "If available, Enter the contact phone number of the site manager for communication purposes."
                                }
                              /> */}
                              {props.touched.siteManagerPhone &&
                                props.errors.siteManagerPhone && (
                                  <p className="text-danger">
                                    {props.errors.siteManagerPhone}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Number of Staff (If Available)
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput type="text" name="numberOfStaff" />
                              {/* <DynamicTooltip
                                label={
                                  "Enter the total number of staff members assigned to manage the site."
                                }
                              /> */}
                              {props.touched.numberOfStaff &&
                                props.errors.numberOfStaff && (
                                  <p className="text-danger">
                                    {props.errors.numberOfStaff}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {step === 3 && (
                    <>
                      <h2 className="m-0 p-2">Land Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Land Details:</h3>
                              This will give us an idea about the terrain and
                              the area we are utilising for site identification.
                            </p>

                            <ul>
                              <li>
                                <b>Soil Type:</b>This helps us understand the
                                foundation requirement to construct the
                                polyhouse.
                              </li>
                              <li>
                                {" "}
                                <b>Total available area:</b> This helps us plan
                                the direction of the polyhouse in a way, we can
                                expand it in the future with minimal effort and
                                cost.
                              </li>
                              <li>
                                {" "}
                                <b>Land Levelling:</b> This will help us to get
                                a head start before project construction. If the
                                land is not level, we might need to level it
                                before we start our construction.
                              </li>
                              <li>
                                {" "}
                                <b>Natural Slope of Land:</b> This helps us
                                understand water flow on land, which is required
                                especially during the rainy season.
                              </li>
                              <li>
                                {" "}
                                <b>Land Ownership:</b> This will help us
                                identify a list of documents we need to prepare
                                to go for a government subsidy.
                              </li>
                              <li>
                                {" "}
                                <b>Tree, Stone, Pond, Mud Patch, Hill Lock:</b>
                                This is general information we need to
                                understand the terrain better.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Soil Type
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect type="text" name="soilType">
                                <option value="">select </option>
                                <option value="blackSoil">Black Soil</option>
                                <option value="redSoil">Red Soil</option>
                                <option value="dusty">Dusty</option>
                                <option value="concrete">Concrete</option>
                                <option value="sand">Sand</option>
                                <option value="vertisol">Vertisol</option>
                                <option value="stoned">Stoned</option>
                                <option value="hardToFind">Hard To Find</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select the type of soil present at the site, such as "Black Soil", "Red Soil", "Sand", etc.'
                                }
                              /> */}
                              {props.touched.soilType &&
                                props.errors.soilType && (
                                  <p className="text-danger">
                                    {props.errors.soilType}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Total available area number
                            </label>

                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="totalAvailableAreaNumber"
                                type={"text"}
                              />
                              {/* <DynamicTooltip
                                label={
                                  'Enter the total available area of the land in numerical value, such as "5" or "10.5".'
                                }
                              /> */}
                              {props.touched.totalAvailableAreaNumber &&
                                props.errors.totalAvailableAreaNumber && (
                                  <p className="text-danger">
                                    {props.errors.totalAvailableAreaNumber}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Total Available Area Unit
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                type="text"
                                name="totalAvailableAreaUnit"
                              >
                                <option value="">select </option>
                                <option value="acre">Acre</option>
                                <option value="hectare">Hectare</option>
                                <option value="guntha">Guntha</option>
                                <option value="cent">Cent</option>
                                <option value="sqft">Square Feet (sqft)</option>
                                <option value="sqmt">
                                  Square Meter (sqmt)
                                </option>
                                <option value="yard">Yard</option>
                                <option value="bigha">Bigha</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select the unit of measurement for the total available area, such as "Acre", "Hectare", "Square Feet", etc.'
                                }
                              /> */}
                              {props.touched.totalAvailableAreaUnit &&
                                props.errors.totalAvailableAreaUnit && (
                                  <p className="text-danger">
                                    {props.errors.totalAvailableAreaUnit}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Land Leveling
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect type="text" name="landLeveling">
                                <option value="">select </option>
                                <option value="required">Required</option>
                                <option value="alreadyDone">
                                  Already Done
                                </option>
                                <option value="hardToFindOut">
                                  Hard to Find Out
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select the land leveling status, such as "Required", "Already Done", or "Hard to Find Out".'
                                }
                              /> */}
                              {props.touched.landLeveling &&
                                props.errors.landLeveling && (
                                  <p className="text-danger">
                                    {props.errors.landLeveling}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Natural Slope of Land
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                type="text"
                                name="naturalSlopeOfLand"
                              >
                                <option value="">select </option>
                                <option value="north">North</option>
                                <option value="south">South</option>
                                <option value="east">East</option>
                                <option value="west">West</option>
                                <option value="northEast">North-East</option>
                                <option value="northWest">North-West</option>
                                <option value="southEast">South-East</option>
                                <option value="southWest">South-West</option>
                                <option value="hardToFind">Hard To Find</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select the natural slope direction of the land, such as "North", "South", "East", etc.'
                                }
                              /> */}
                              {props.touched.naturalSlopeOfLand &&
                                props.errors.naturalSlopeOfLand && (
                                  <p className="text-danger">
                                    {props.errors.naturalSlopeOfLand}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Land Ownership
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect type="text" name="landOwnership">
                                <option value="">select </option>
                                <option value="own">Own</option>
                                <option value="rent">Rent</option>
                                <option value="leased">Leased</option>
                                <option value="partnership">Partnership</option>
                                <option value="planning to purchase">
                                  Planning To Purchase
                                </option>
                                <option value="planning to lease">
                                  Planning To Lease
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  'select the land ownership status, such as "Own", "Rent", "Leased", etc.'
                                }
                              /> */}
                              {props.touched.landOwnership &&
                                props.errors.landOwnership && (
                                  <p className="text-danger">
                                    {props.errors.landOwnership}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="row">
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3 col">
                                Land has tree
                              </label>
                              <div className="ps-2 col-lg-9 col-3">
                                <CustomCheckbox
                                  name="landHasTree"
                                  type="checkbox"
                                  width={"17px"}
                                  height={"17px"}
                                />

                                {props.touched.landHasTree &&
                                  props.errors.landHasTree && (
                                    <p className="text-danger">
                                      {props.errors.landHasTree}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3 col">
                                Land has stones
                              </label>
                              <div className="ps-2 col-lg-9 col-3">
                                <CustomCheckbox
                                  name="landHasStones"
                                  type="checkbox"
                                  width={"17px"}
                                  height={"17px"}
                                />
                                {props.touched.landHasStones &&
                                  props.errors.landHasStones && (
                                    <p className="text-danger">
                                      {props.errors.landHasStones}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3 col">
                                Land has pond
                              </label>
                              <div className="ps-2 col-lg-9 col-3">
                                <CustomCheckbox
                                  name="landHasPond"
                                  type="checkbox"
                                  width={"17px"}
                                  height={"17px"}
                                />
                                {props.touched.landHasPond &&
                                  props.errors.landHasPond && (
                                    <p className="text-danger">
                                      {props.errors.landHasPond}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3 col">
                                Land has mud patch
                              </label>
                              <div className="ps-2 col-lg-9 col-3">
                                <CustomCheckbox
                                  name="landHasMudPatch"
                                  type="checkbox"
                                  width={"17px"}
                                  height={"17px"}
                                />
                                {props.touched.landHasMudPatch &&
                                  props.errors.landHasMudPatch && (
                                    <p className="text-danger">
                                      {props.errors.landHasMudPatch}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3 col">
                                Land has hill lock
                              </label>
                              <div className="ps-2 col-lg-9 col-3">
                                <CustomCheckbox
                                  name="landHasHillock"
                                  type="checkbox"
                                  width={"17px"}
                                  height={"17px"}
                                />
                                {props.touched.landHasHillock &&
                                  props.errors.landHasHillock && (
                                    <p className="text-danger">
                                      {props.errors.landHasHillock}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 4 && (
                    <>
                      <h2 className="m-0 p-2">Dimension Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Dimension Details:</h3>
                              This will give us idea about the actual
                              construction sit
                            </p>

                            <ul>
                              <li>
                                <b>North, East, South, West:</b> This will give
                                us an idea about what to expect for future
                                development or to analyse the threat.
                              </li>
                              <li>
                                {" "}
                                <b>Obstacles towards the sky:</b> This will give
                                us a clear idea if we have a clear 6.5 mtr+
                                height available for the construction of the
                                polyhouse.
                              </li>
                              <li>
                                {" "}
                                <b>Land fencing:</b> This will give us an idea
                                about on-site security, during construction and
                                after construction as well.
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Whats on north
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="whatsOnNorth" type="text">
                                <option value="">select</option>
                                <option value="ownLand">Own Land</option>
                                <option value="landBelongsToSomeoneElse">
                                  Land Belongs to Someone Else
                                </option>
                                <option value="waterBody">Water Body</option>
                                <option value="road">Road</option>
                                <option value="fencing">Fencing</option>
                                <option value="wall">Wall</option>

                                <option value="slopeLand">Slope Land</option>
                                <option value="disputedLand">
                                  Disputed Land
                                </option>
                                <option value="governmentLand">
                                  Government Land
                                </option>
                                <option value="other">Other</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "select what is present on the north side of the site from the available options"
                              }
                            /> */}
                              {props.touched.whatsOnNorth &&
                                props.errors.whatsOnNorth && (
                                  <p className="text-danger">
                                    {props.errors.whatsOnNorth}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Whats on east
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="whatsOnEast" type="text">
                                <option value="">select</option>
                                <option value="ownLand">Own Land</option>
                                <option value="landBelongsToSomeoneElse">
                                  Land Belongs to Someone Else
                                </option>
                                <option value="waterBody">Water Body</option>
                                <option value="road">Road</option>
                                <option value="fencing">Fencing</option>
                                <option value="wall">Wall</option>
                                <option value="slopeLand">Slope Land</option>
                                <option value="disputedLand">
                                  Disputed Land
                                </option>
                                <option value="governmentLand">
                                  Government Land
                                </option>
                                <option value="other">Other</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "select what is present on the east side of the site from the available options"
                              }
                            /> */}
                              {props.touched.whatsOnEast &&
                                props.errors.whatsOnEast && (
                                  <p className="text-danger">
                                    {props.errors.whatsOnEast}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Whats on south
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="whatsOnSouth" type="text">
                                <option value="">select</option>
                                <option value="ownLand">Own Land</option>
                                <option value="landBelongsToSomeoneElse">
                                  Land Belongs to Someone Else
                                </option>
                                <option value="waterBody">Water Body</option>
                                <option value="road">Road</option>
                                <option value="fencing">Fencing</option>
                                <option value="wall">Wall</option>
                                <option value="slopeLand">Slope Land</option>
                                <option value="disputedLand">
                                  Disputed Land
                                </option>
                                <option value="governmentLand">
                                  Government Land
                                </option>
                                <option value="other">Other</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                " select what is present on the south side of the site from the available options"
                              }
                            /> */}
                              {props.touched.whatsOnSouth &&
                                props.errors.whatsOnSouth && (
                                  <p className="text-danger">
                                    {props.errors.whatsOnSouth}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Whats on west
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="whatsOnWest" type="text">
                                <option value="">select</option>
                                <option value="ownLand">Own Land</option>
                                <option value="landBelongsToSomeoneElse">
                                  Land Belongs to Someone Else
                                </option>
                                <option value="waterBody">Water Body</option>
                                <option value="road">Road</option>
                                <option value="fencing">Fencing</option>
                                <option value="wall">Wall</option>
                                <option value="slopeLand">Slope Land</option>
                                <option value="disputedLand">
                                  Disputed Land
                                </option>
                                <option value="governmentLand">
                                  Government Land
                                </option>
                                <option value="other">Other</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "select what is present on the west side of the site from the available options"
                              }
                            /> */}
                              {props.touched.whatsOnWest &&
                                props.errors.whatsOnWest && (
                                  <p className="text-danger">
                                    {props.errors.whatsOnWest}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 ">
                              Obstacles towards sky
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="obstaclesTowardsSky"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether there are any obstacles towards the sky by checking this box if applicable. like trees, buildings, etc."
                              }
                            /> */}
                              {props.touched.obstaclesTowardsSky &&
                                props.errors.obstaclesTowardsSky && (
                                  <p className="text-danger">
                                    {props.errors.obstaclesTowardsSky}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Obstacles towards sky photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="obstaclesTowardsSkyPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "obstaclesTowardsSkyPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo showing any obstacles towards the sky, such as trees or buildings, if applicable."
                              }
                            /> */}
                              {props.touched.obstaclesTowardsSkyPhoto &&
                                props.errors.obstaclesTowardsSkyPhoto && (
                                  <p className="text-danger">
                                    {props.errors.obstaclesTowardsSkyPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                          {/* <div className="mb-3 row">
                          <label className="form-label col-lg-3">
                            North south measurment in meter
                          </label>
                          <div className="col-lg-9 position-relative">
                            <CustomInput
                              name="northSouthMeasurmentInMeter"
                              type="text"
                            />
                            <DynamicTooltip
                              label={
                                "Enter the north-south measurement of the site in meters, indicating the distance from the northernmost to the southernmost point."
                              }
                            />
                            {props.touched.northSouthMeasurmentInMeter &&
                              props.errors.northSouthMeasurmentInMeter && (
                                <p className="text-danger">
                                  {props.errors.northSouthMeasurmentInMeter}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="form-label col-lg-3">
                            North south measurment photo
                          </label>
                          <div className="col-lg-9 position-relative">
                            <CustomInput
                              name="northSouthMeasurmentPhoto"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "northSouthMeasurmentPhoto",
                                  e.target.files[0]
                                )
                              }
                            />
                            <DynamicTooltip
                              label={
                                "Upload a photo showing the north-south measurement of the site in meters."
                              }
                            />
                            {props.touched.northSouthMeasurmentPhoto &&
                              props.errors.northSouthMeasurmentPhoto && (
                                <p className="text-danger">
                                  {props.errors.northSouthMeasurmentPhoto}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="form-label col-lg-3">
                            East west measurment in meter
                          </label>
                          <div className="col-lg-9 position-relative">
                            <CustomInput
                              name="eastWestMeasurmentInMeter"
                              type="text"
                            />
                            <DynamicTooltip
                              label={
                                "Enter the east-west measurement of the site in meters, indicating the distance from the easternmost to the westernmost point."
                              }
                            />
                            {props.touched.eastWestMeasurmentInMeter &&
                              props.errors.eastWestMeasurmentInMeter && (
                                <p className="text-danger">
                                  {props.errors.eastWestMeasurmentInMeter}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="form-label col-lg-3">
                            East west measurment photo
                          </label>
                          <div className="col-lg-9 position-relative">
                            <CustomInput
                              name="eastWestMeasurmentPhoto"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "eastWestMeasurmentPhoto",
                                  e.target.files[0]
                                )
                              }
                            />
                            <DynamicTooltip
                              label={
                                "Upload a photo showing the east-west measurement of the site in meters."
                              }
                            />
                            {props.touched.eastWestMeasurmentPhoto &&
                              props.errors.eastWestMeasurmentPhoto && (
                                <p className="text-danger">
                                  {props.errors.eastWestMeasurmentPhoto}
                                </p>
                              )}
                          </div>
                        </div> */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Layout photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="layoutPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "layoutPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo showing the overall layout of the site."
                              }
                            /> */}
                              {props.touched.layoutPhoto &&
                                props.errors.layoutPhoto && (
                                  <p className="text-danger">
                                    {props.errors.layoutPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Land fencing type
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="landFencingType" type="text">
                                <option value="">select</option>
                                <option value="noFencing">No Fencing</option>
                                <option value="stoned">Stoned</option>
                                <option value="cementPoll">Cement Poll</option>
                                <option value="cementWall">Cement Wall</option>
                                <option value="preFab">Prefabricated</option>
                                <option value="wired">Wired</option>
                                <option value="makeShift">Make Shift</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                'select the type of land fencing present at the site, such as "No Fencing", "Stoned", "Cement Wall", etc.'
                              }
                            /> */}
                              {props.touched.landFencingType &&
                                props.errors.landFencingType && (
                                  <p className="text-danger">
                                    {props.errors.landFencingType}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Land fencing height in feet
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="landFencingHeightInFeet"
                                type="text"
                              />
                              {/* <DynamicTooltip
                              label={
                                "Enter the height of the land fencing in feet."
                              }
                            /> */}
                              {props.touched.landFencingHeightInFeet &&
                                props.errors.landFencingHeightInFeet && (
                                  <p className="text-danger">
                                    {props.errors.landFencingHeightInFeet}
                                  </p>
                                )}
                            </div>
                          </div>
                          {/* <div className="mb-3 row">
                          <label className="form-label col-lg-3">
                            Polyhouse costruction layout
                          </label>
                          <div className="col-lg-9 position-relative">
                            <CustomInput
                              name="costructionLayout"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "costructionLayout",
                                  e.target.files[0]
                                )
                              }
                            />
                            <DynamicTooltip
                              label={
                                "Upload a photo showing the polyhouse construction layout. contact to get this layout to your sales manager."
                              }
                            />
                            {props.touched.costructionLayout &&
                              props.errors.costructionLayout && (
                                <p className="text-danger">
                                  {props.errors.costructionLayout}
                                </p>
                              )}
                          </div>
                        </div> */}
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Polyhouse system layout
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="systemLayout"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "systemLayout",
                                    e.target.files[0]
                                  )
                                }
                              />{" "}
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo showing the polyhouse system layout. contact to get this layout to your sales manager."
                              }
                            /> */}
                              {props.touched.systemLayout &&
                                props.errors.systemLayout && (
                                  <p className="text-danger">
                                    {props.errors.systemLayout}
                                  </p>
                                )}
                            </div>
                          </div>
                          {/* <div className="mb-3 row">
                          <label className="form-label col-lg-3">
                            Polyhouse - end view
                          </label>
                          <div className="col-lg-9 position-relative">
                            <CustomInput
                              name="pEndView"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "pEndView",
                                  e.target.files[0]
                                )
                              }
                            />
                            <DynamicTooltip
                              label={
                                "Upload a photo showing the end view of the polyhouse structure. contact to get this layout to your sales manager."
                              }
                            />
                            {props.touched.pEndView &&
                              props.errors.pEndView && (
                                <p className="text-danger">
                                  {props.errors.pEndView}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="form-label col-lg-3">
                            Polyhouse - center view
                          </label>
                          <div className="col-lg-9 position-relative">
                            <CustomInput
                              name="pCenterView"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "pCenterView",
                                  e.target.files[0]
                                )
                              }
                            />
                            <DynamicTooltip
                              label={
                                "Upload a photo showing the center view of the polyhouse structure. contact to get this layout to your sales manager."
                              }
                            />
                            {props.touched.pCenterView &&
                              props.errors.pCenterView && (
                                <p className="text-danger">
                                  {props.errors.pCenterView}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="form-label col-lg-3">
                            Polyhouse - side view
                          </label>
                          <div className="col-lg-9 position-relative">
                            <CustomInput
                              name="pSideView"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "pSideView",
                                  e.target.files[0]
                                )
                              }
                            />
                            <DynamicTooltip
                              label={
                                "Upload a photo showing the polyhouse construction layout. contact to get this layout to your sales manager."
                              }
                            />
                            {props.touched.pSideView &&
                              props.errors.pSideView && (
                                <p className="text-danger">
                                  {props.errors.pSideView}
                                </p>
                              )}
                          </div>
                        </div> */}
                        </div>
                      </div>
                    </>
                  )}

                  {step === 5 && (
                    <>
                      <h2 className="m-0 p-2">Measurment Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Measurement Details:</h3>
                              Make sure you get accurate measurement details.
                              Don't forget to upload a video of the
                              measurements. These land measurements are the most
                              crucial part of the project. If this dimentions
                              are wrong, this will affect our quotation,
                              material planning and it might result into delay
                              of project construction.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              North south measurment in meter
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="northSouthMeasurmentInMeter"
                                type="text"
                              />
                              {/* <DynamicTooltip
                              label={
                                "Enter the north-south measurement of the site in meters, indicating the distance from the northernmost to the southernmost point."
                              }
                            /> */}
                              {props.touched.northSouthMeasurmentInMeter &&
                                props.errors.northSouthMeasurmentInMeter && (
                                  <p className="text-danger">
                                    {props.errors.northSouthMeasurmentInMeter}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              North south measurment photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="northSouthMeasurmentPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "northSouthMeasurmentPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo showing the north-south measurement of the site in meters."
                              }
                            /> */}
                              {props.touched.northSouthMeasurmentPhoto &&
                                props.errors.northSouthMeasurmentPhoto && (
                                  <p className="text-danger">
                                    {props.errors.northSouthMeasurmentPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              North south measurment video
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="northSouthMeasurmentViedo"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "northSouthMeasurmentViedo",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a viedo showing the north-south measurement of the site in meters."
                              }
                            /> */}
                              {props.touched.northSouthMeasurmentViedo &&
                                props.errors.northSouthMeasurmentViedo && (
                                  <p className="text-danger">
                                    {props.errors.northSouthMeasurmentViedo}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              East west measurment in meter
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="eastWestMeasurmentInMeter"
                                type="text"
                              />
                              {/* <DynamicTooltip
                              label={
                                "Enter the east-west measurement of the site in meters, indicating the distance from the easternmost to the westernmost point."
                              }
                            /> */}
                              {props.touched.eastWestMeasurmentInMeter &&
                                props.errors.eastWestMeasurmentInMeter && (
                                  <p className="text-danger">
                                    {props.errors.eastWestMeasurmentInMeter}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              East west measurment photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="eastWestMeasurmentPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "eastWestMeasurmentPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo showing the east-west measurement of the site in meters."
                              }
                            /> */}
                              {props.touched.eastWestMeasurmentPhoto &&
                                props.errors.eastWestMeasurmentPhoto && (
                                  <p className="text-danger">
                                    {props.errors.eastWestMeasurmentPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              East west measurment video
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="eastWestMeasurmentViedo"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "eastWestMeasurmentViedo",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a viedo showing the east-west measurement of the site in meters."
                              }
                            /> */}
                              {props.touched.eastWestMeasurmentViedo &&
                                props.errors.eastWestMeasurmentViedo && (
                                  <p className="text-danger">
                                    {props.errors.eastWestMeasurmentViedo}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 6 && (
                    <>
                      <h2 className="m-0 p-2">Water Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Water Details:</h3>
                              In hydroponics water is most crucial part of site
                              inspection. This will give us idea about selection
                              of crop, the selection of system and most
                              importantly operational cost of project.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row mt-1">
                            <label className="form-label col-lg-3">
                              Mark Water Not Available
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="markWaterNotAvailable"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Check this box if water is not available at the site."
                              }
                            /> */}
                              {props.touched.markWaterNotAvailable &&
                                props.errors.markWaterNotAvailable && (
                                  <p className="text-danger">
                                    {props.errors.markWaterNotAvailable}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Water source type
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="waterSourceType" type="text">
                                <option value="">select</option>
                                <option value="borewell">Borewell</option>
                                <option value="well">Well</option>
                                <option value="municipalWater">
                                  Municipal Water
                                </option>
                                <option value="pond">Pond</option>
                                <option value="rainHarvesting">
                                  Rain Harvesting
                                </option>
                                <option value="tanker">Tanker</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the type of water source available at the site, such as Borewell, Well, Municipal Water, etc."
                              }
                            /> */}
                              {props.touched.waterSourceType &&
                                props.errors.waterSourceType && (
                                  <p className="text-danger">
                                    {props.errors.waterSourceType}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Water tank capacity in litre
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="waterTankCapacityInLitre"
                                type="text"
                              />
                              {/* <DynamicTooltip
                              label={
                                "Enter the capacity of the water tank in litres."
                              }
                            /> */}
                              {props.touched.waterTankCapacityInLitre &&
                                props.errors.waterTankCapacityInLitre && (
                                  <p className="text-danger">
                                    {props.errors.waterTankCapacityInLitre}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Water availability frequency
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                name="waterAvailabilityFrequency"
                                type="text"
                              >
                                <option value="">select</option>
                                <option value="uninterrupted">
                                  Uninterrupted
                                </option>
                                <option value="onDemand">On Demand</option>
                                <option value="onAvailabilityOfElectricity">
                                  On Availability of Electricity
                                </option>
                                <option value="onceAday">Once a Day</option>
                                <option value="onceAweek">Once a Week</option>
                                <option value="onceAmonth">Once a Month</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the frequency of water availability at the site, such as Uninterrupted, On Demand, Once a Day, etc."
                              }
                            /> */}
                              {props.touched.waterAvailabilityFrequency &&
                                props.errors.waterAvailabilityFrequency && (
                                  <p className="text-danger">
                                    {props.errors.waterAvailabilityFrequency}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Position of water tank
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                name="positionOfWaterTank"
                                type="text"
                              >
                                <option value="">select</option>
                                <option value="north">North</option>
                                <option value="south">South</option>
                                <option value="east">East</option>
                                <option value="west">West</option>
                                <option value="northEast">North-East</option>
                                <option value="northWest">North-West</option>
                                <option value="southEast">South-East</option>
                                <option value="southWest">South-West</option>
                                <option value="unclear">Unclear</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the position of the water tank on the site, such as North, South, East, West, etc."
                              }
                            /> */}
                              {props.touched.positionOfWaterTank &&
                                props.errors.positionOfWaterTank && (
                                  <p className="text-danger">
                                    {props.errors.positionOfWaterTank}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Water tank location photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="waterTankLocationPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "waterTankLocationPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo showing the location of the water tank on the site."
                              }
                            /> */}
                              {props.touched.waterTankLocationPhoto &&
                                props.errors.waterTankLocationPhoto && (
                                  <p className="text-danger">
                                    {props.errors.waterTankLocationPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Water Ph reading
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput name="waterPhReading" type="text" />
                              {/* <DynamicTooltip
                              label={
                                "Enter the pH reading of the water at the site."
                              }
                            /> */}
                              {props.touched.waterPhReading &&
                                props.errors.waterPhReading && (
                                  <p className="text-danger">
                                    {props.errors.waterPhReading}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Water Ec reading (in ppm)
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput name="waterEcReading" type="text" />
                              {/* <DynamicTooltip
                              label={
                                "Enter the Electrical Conductivity (EC) reading of the water at the site in parts per million (ppm)."
                              }
                            /> */}
                              {props.touched.waterEcReading &&
                                props.errors.waterEcReading && (
                                  <p className="text-danger">
                                    {props.errors.waterEcReading}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Water report photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="waterReportPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "waterReportPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo of the water quality report for the site."
                              }
                            /> */}
                              {props.touched.waterReportPhoto &&
                                props.errors.waterReportPhoto && (
                                  <p className="text-danger">
                                    {props.errors.waterReportPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 7 && (
                    <>
                      <h2 className="m-0 p-2">Sunlight Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Sunlight Details:</h3>
                              The lux reading of sunlight will help us
                              understand the plant photosynthesis capacity of
                              the location. this will also help into finding the
                              crops that can be grown with minimum efforts and
                              cost. with better yield prospects.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Entry to farm site
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="entryToFarmSite" type="text">
                                <option value="">select</option>
                                <option value="north">North</option>
                                <option value="south">South</option>
                                <option value="east">East</option>
                                <option value="west">West</option>
                                <option value="northEast">North-East</option>
                                <option value="northWest">North-West</option>
                                <option value="southEast">South-East</option>
                                <option value="southWest">South-West</option>
                                <option value="unclear">Unclear</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the direction of entry to the farm site, such as North, South, East, West, etc."
                              }
                            /> */}
                              {props.touched.entryToFarmSite &&
                                props.errors.entryToFarmSite && (
                                  <p className="text-danger">
                                    {props.errors.entryToFarmSite}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Entry to farm photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="entryTofarmPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "entryTofarmPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo showing the entry point to the farm site."
                              }
                            /> */}
                              {props.touched.entryTofarmPhoto &&
                                props.errors.entryTofarmPhoto && (
                                  <p className="text-danger">
                                    {props.errors.entryTofarmPhoto}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Lux Uv open
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput name="luxUvOpen" type="text" />
                              {/* <DynamicTooltip
                              label={
                                "Enter the Lux UV reading when the site is open."
                              }
                            /> */}
                              {props.touched.luxUvOpen &&
                                props.errors.luxUvOpen && (
                                  <p className="text-danger">
                                    {props.errors.luxUvOpen}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Lux Uv open photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="luxUvOpenPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "luxUvOpenPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a photo showing the Lux UV reading when the site is open."
                              }
                            /> */}
                              {props.touched.luxUvOpenPhoto &&
                                props.errors.luxUvOpenPhoto && (
                                  <p className="text-danger">
                                    {props.errors.luxUvOpenPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {step === 8 && (
                    <>
                      <h2 className="m-0 p-2">Climate Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Climate Details:</h3>
                              Climate details like temperature and humidity will
                              help us identify the system that we need. Based on
                              this todays temperature and humidity data, clubbed
                              with latitude and longitude we gathered earlier,
                              we will be able to pull details of last 5 years of
                              temperature and humidity graph. Giving us clear
                              idea about selection of system and crops.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Temperature reading (in °F)
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="temperatureReading"
                                type="text"
                              />
                              {/* <DynamicTooltip
                                label={
                                  "Enter the temperature reading at the site in degrees Fahrenheit (°F)."
                                }
                              /> */}
                              {props.touched.temperatureReading &&
                                props.errors.temperatureReading && (
                                  <p className="text-danger">
                                    {props.errors.temperatureReading}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Temperature reading photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="temperatureReadingPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "temperatureReadingPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                                label={
                                  "Upload a photo showing the temperature reading at the site."
                                }
                              /> */}
                              {props.touched.temperatureReadingPhoto &&
                                props.errors.temperatureReadingPhoto && (
                                  <p className="text-danger">
                                    {props.errors.temperatureReadingPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Humidity reading
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput name="humidityReading" type="text" />
                              {/* <DynamicTooltip
                                label={
                                  "Enter the humidity reading at the site as a percentage (%)."
                                }
                              /> */}
                              {props.touched.humidityReading &&
                                props.errors.humidityReading && (
                                  <p className="text-danger">
                                    {props.errors.humidityReading}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Humidity reading photo
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="humidityReadingPhoto"
                                type="file"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "humidityReadingPhoto",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                                label={
                                  "Upload a photo showing the humidity reading at the site."
                                }
                              /> */}
                              {props.touched.humidityReadingPhoto &&
                                props.errors.humidityReadingPhoto && (
                                  <p className="text-danger">
                                    {props.errors.humidityReadingPhoto}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Climate hottest month
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                name="climateHottestMonth"
                                type="text"
                              >
                                <option value="">select</option>
                                <option value="january">January</option>
                                <option value="february">February</option>
                                <option value="march">March</option>
                                <option value="april">April</option>
                                <option value="may">May</option>
                                <option value="june">June</option>
                                <option value="july">July</option>
                                <option value="august">August</option>
                                <option value="september">September</option>
                                <option value="october">October</option>
                                <option value="november">November</option>
                                <option value="december">December</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  "Select the hottest month of the year at the site."
                                }
                              /> */}
                              {props.touched.climateHottestMonth &&
                                props.errors.climateHottestMonth && (
                                  <p className="text-danger">
                                    {props.errors.climateHottestMonth}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Climate coldest month
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                name="climateColdestMonth"
                                type="text"
                              >
                                <option value="">select</option>
                                <option value="january">January</option>
                                <option value="february">February</option>
                                <option value="march">March</option>
                                <option value="april">April</option>
                                <option value="may">May</option>
                                <option value="june">June</option>
                                <option value="july">July</option>
                                <option value="august">August</option>
                                <option value="september">September</option>
                                <option value="october">October</option>
                                <option value="november">November</option>
                                <option value="december">December</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                                label={
                                  "Select the coldest month of the year at the site."
                                }
                              /> */}
                              {props.touched.climateColdestMonth &&
                                props.errors.climateColdestMonth && (
                                  <p className="text-danger">
                                    {props.errors.climateColdestMonth}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 9 && (
                    <>
                      <h2 className="m-0 p-2">Facilities</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Facilities:</h3>
                              These are collected to understand the livability
                              of space for the labourers that will come on site
                              to construct the project.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 col">
                              Facility to store items
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="facilityToStoreItems"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether there is a facility available at the site to store items."
                              }
                            /> */}
                              {props.touched.facilityToStoreItems &&
                                props.errors.facilityToStoreItems && (
                                  <p className="text-danger">
                                    {props.errors.facilityToStoreItems}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 col">
                              Facility to stay
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="facilityToStay"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether there is a facility available at the site to stay overnight."
                              }
                            /> */}
                              {props.touched.facilityToStay &&
                                props.errors.facilityToStay && (
                                  <p className="text-danger">
                                    {props.errors.facilityToStay}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 col">
                              Facility has bathroom
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="facilityHasBathroom"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether the facility at the site has a bathroom."
                              }
                            /> */}
                              {props.touched.facilityHasBathroom &&
                                props.errors.facilityHasBathroom && (
                                  <p className="text-danger">
                                    {props.errors.facilityHasBathroom}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 col">
                              Facility has drinking water
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="facilityHasDrinkingWater"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether the facility at the site has access to drinking water."
                              }
                            /> */}
                              {props.touched.facilityHasDrinkingWater &&
                                props.errors.facilityHasDrinkingWater && (
                                  <p className="text-danger">
                                    {props.errors.facilityHasDrinkingWater}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 col">
                              Facility has kitchen space
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="facilityHasKitchenSpace"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether the facility at the site has a designated kitchen space."
                              }
                            /> */}
                              {props.touched.facilityHasKitchenSpace &&
                                props.errors.facilityHasKitchenSpace && (
                                  <p className="text-danger">
                                    {props.errors.facilityHasKitchenSpace}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 col">
                              Facility has fuel for cooking
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="facilityHasFuelForCooking"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether the facility at the site has fuel available for cooking."
                              }
                            /> */}
                              {props.touched.facilityHasFuelForCooking &&
                                props.errors.facilityHasFuelForCooking && (
                                  <p className="text-danger">
                                    {props.errors.facilityHasFuelForCooking}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 10 && (
                    <>
                      <h2 className="m-0 p-2">Transport Options</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Transport Options:</h3>
                              This will be used to plan the vehicle and
                              materials to the site of construction.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Transport option
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="transportOption" type="text">
                                <option value="">select</option>
                                <option value="byRoad">By Road</option>
                                <option value="byWater">By Water</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the primary mode of transport to access the site, such as By Road or By Water."
                              }
                            /> */}
                              {props.touched.transportOption &&
                                props.errors.transportOption && (
                                  <p className="text-danger">
                                    {props.errors.transportOption}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Nearest tar road
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="nearestTarRoad" type="text">
                                <option value="">select</option>
                                <option value="0km To 1km">0km - 1km</option>
                                <option value="1km To 3km">1km - 3km</option>
                                <option value="3km To 5km">3km - 5km</option>
                                <option value="5km To 20km">5km - 20km</option>
                                <option value="20km To 50km">
                                  20km - 50km
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the distance to the nearest tar road from the site, such as 0km - 1km, 1km - 3km, etc."
                              }
                            /> */}
                              {props.touched.nearestTarRoad &&
                                props.errors.nearestTarRoad && (
                                  <p className="text-danger">
                                    {props.errors.nearestTarRoad}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Regular mode of transportation
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                name="regulerModeOfTransportation"
                                type="text"
                              >
                                <option value="">select</option>
                                <option value="ownVehicle">Own Vehicle</option>
                                <option value="privateVehicle">
                                  Private Vehicle
                                </option>
                                <option value="governmentVehicle">
                                  Government Vehicle
                                </option>
                                <option value="train">Train</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the regular mode of transportation used to access the site, such as Own Vehicle, Private Vehicle, Government Vehicle, or Train."
                              }
                            /> */}
                              {props.touched.regulerModeOfTransportation &&
                                props.errors.regulerModeOfTransportation && (
                                  <p className="text-danger">
                                    {props.errors.regulerModeOfTransportation}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Vehicle avilable for emergency
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                name="vehicleAvilableForEmergency"
                                type="text"
                              >
                                <option value="">select</option>
                                <option value="unavailable">Unavailable</option>
                                <option value="2 wheeler">2 Wheeler</option>
                                <option value="3 wheeler">3 Wheeler</option>
                                <option value="4 wheeler">4 Wheeler</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the type of vehicle available for emergency situations at the site, such as Unavailable, 2 Wheeler, 3 Wheeler, or 4 Wheeler."
                              }
                            /> */}
                              {props.touched.vehicleAvilableForEmergency &&
                                props.errors.vehicleAvilableForEmergency && (
                                  <p className="text-danger">
                                    {props.errors.vehicleAvilableForEmergency}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 11 && (
                    <>
                      <h2 className="m-0 p-2">Nearest Facilities</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Nearest Facilities:</h3>
                              This will help us understand the nearest market
                              and possible sells or transport options to grown
                              uo goods like vegetables.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Nearest hardware shop
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="nearestMarket">
                                <option value="">Select</option>
                                <option value="0km To 1km">0km - 1km</option>
                                <option value="1km To 3km">1km - 3km</option>
                                <option value="3km To 5km">3km - 5km</option>
                                <option value="5km To 20km">5km - 20km</option>
                                <option value="20km To 50km">
                                  20km - 50km
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the distance to the nearest hardware shop from the site, such as 0km - 1km, 1km - 3km, etc."
                              }
                            /> */}
                              {props.touched.nearestMarket &&
                                props.errors.nearestMarket && (
                                  <p className="text-danger">
                                    {props.errors.nearestMarket}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Nearest hospital
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="nearestMedicalFacility">
                                <option value="">Select</option>
                                <option value="0km To 1km">0km - 1km</option>
                                <option value="1km To 3km">1km - 3km</option>
                                <option value="3km To 5km">3km - 5km</option>
                                <option value="5km To 20km">5km - 20km</option>
                                <option value="20km To 50km">
                                  20km - 50km
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the distance to the nearest hospital from the site, such as 0km - 1km, 1km - 3km, etc."
                              }
                            /> */}
                              {props.touched.nearestMedicalFacility &&
                                props.errors.nearestMedicalFacility && (
                                  <p className="text-danger">
                                    {props.errors.nearestMedicalFacility}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Nearest stay facility
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                name="nearestStayFacility"
                                type="text"
                              >
                                <option value="">select</option>
                                <option value="0km To 1km">0km - 1km</option>
                                <option value="1km To 3km">1km - 3km</option>
                                <option value="3km To 5km">3km - 5km</option>
                                <option value="5km To 20km">5km - 20km</option>
                                <option value="20km To 50km">
                                  20km - 50km
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the distance to the nearest stay facility from the site, such as 0km - 1km, 1km - 3km, etc."
                              }
                            /> */}
                              {props.touched.nearestStayFacility &&
                                props.errors.nearestStayFacility && (
                                  <p className="text-danger">
                                    {props.errors.nearestStayFacility}
                                  </p>
                                )}
                            </div>
                          </div>

                          {[
                            {
                              label: "Nearest bus stand",
                              name: "nearestBusStand",
                              tooltipMsg:
                                "Enter the name of the nearest bus stand to the site.",
                            },
                            {
                              label: "Nearest railway station",
                              name: "nearestRailwayStation",
                              tooltipMsg:
                                "Enter the name of the nearest railway station to the site.",
                            },
                            {
                              label: "Nearest airport",
                              name: "nearestAirport",
                              tooltipMsg:
                                "Enter the name of the nearest airport to the site.",
                            },
                            {
                              label: "Nearest tier-1 city",
                              name: "nearestTier1City",
                              tooltipMsg:
                                "Enter the name of the nearest tier-1 city to the site.",
                            },
                            {
                              label: "Nearest tier-1 city Distance (kms)",
                              name: "nearestTier1CityDistance",
                              tooltipMsg:
                                "Enter the distance to the nearest tier-1 city from the site in kilometers (kms).",
                            },
                            {
                              label: "Nearest tier-2 city",
                              name: "nearestTier2City",
                              tooltipMsg:
                                "Enter the name of the nearest tier-2 city to the site.",
                            },
                            {
                              label: "Nearest tier-2 city Distance (kms)",
                              name: "nearestTier2CityDistance",
                              tooltipMsg:
                                "Enter the distance to the nearest tier-2 city from the site in kilometers (kms).",
                            },
                          ].map(({ label, name, tooltipMsg }) => (
                            <div className="mb-3 row" key={name}>
                              <label className="form-label col-lg-3">
                                {label}
                              </label>
                              <div className="col-lg-9 position-relative">
                                <CustomInput name={name} type="text" />
                                {/* <DynamicTooltip label={tooltipMsg} /> */}
                                {props.touched[name] && props.errors[name] && (
                                  <p className="text-danger">
                                    {props.errors[name]}
                                  </p>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                  {step === 12 && (
                    <>
                      <h2 className="m-0 p-2">Electric Connection</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Electric Connection:</h3>
                              This helps into understanding the power
                              availability as well as the cost of operations.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 col">
                              Electricity Connection Available
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="electricityConnectionAvailable"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether an electricity connection is available at the site."
                              }
                            /> */}
                              {props.touched.electricityConnectionAvailable &&
                                props.errors.electricityConnectionAvailable && (
                                  <p className="text-danger">
                                    {
                                      props.errors
                                        .electricityConnectionAvailable
                                    }
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Electricity Meter Type
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="electricityMeterType">
                                <option value="">Select</option>
                                <option value="residential">Residential</option>
                                <option value="commercial">Commercial</option>
                                <option value="agricultural">
                                  Agricultural
                                </option>
                                <option value="solar">Solar</option>
                                <option value="industrial">Industrial</option>
                                <option value="freeUse">Free Use</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the type of electricity meter installed at the site, such as Residential, Commercial, Agricultural, etc."
                              }
                            /> */}
                              {props.touched.electricityMeterType &&
                                props.errors.electricityMeterType && (
                                  <p className="text-danger">
                                    {props.errors.electricityMeterType}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Electricity Meter Phase Type
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="electricityMeterPhaseType">
                                <option value="">Select</option>
                                <option value="singlePhase">
                                  Single Phase
                                </option>
                                <option value="threePhase">Three Phase</option>
                                <option value="both">Both</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the phase type of the electricity meter at the site, such as Single Phase, Three Phase, or Both."
                              }
                            /> */}
                              {props.touched.electricityMeterPhaseType &&
                                props.errors.electricityMeterPhaseType && (
                                  <p className="text-danger">
                                    {props.errors.electricityMeterPhaseType}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Electricity Outage Frequency
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="electricityOutageFrequency">
                                <option value="">Select</option>
                                <option value="never">Never</option>
                                <option value="sometimes">Sometimes</option>
                                <option value="occasionally">
                                  Occasionally
                                </option>
                                <option value="lowFrequency">
                                  Low Frequency
                                </option>
                                <option value="highFrequency">
                                  High Frequency
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select how frequently electricity outages occur at the site, such as Never, Sometimes, Occasionally, etc."
                              }
                            /> */}
                              {props.touched.electricityOutageFrequency &&
                                props.errors.electricityOutageFrequency && (
                                  <p className="text-danger">
                                    {props.errors.electricityOutageFrequency}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Electricity Unit Price
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="electricityUnitPrice"
                                type="text"
                              />
                              {/* <DynamicTooltip
                              label={
                                "Enter the cost per unit of electricity at the site."
                              }
                            /> */}
                              {props.touched.electricityUnitPrice &&
                                props.errors.electricityUnitPrice && (
                                  <p className="text-danger">
                                    {props.errors.electricityUnitPrice}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Electricity Pricing Model
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="electricityPricingModel">
                                <option value="">Select</option>
                                <option value="uniform">Uniform</option>
                                <option value="bracketed">Bracketed</option>
                                <option value="subsidised">Subsidised</option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the pricing model for electricity at the site, such as Uniform, Bracketed, or Subsidised."
                              }
                            /> */}
                              {props.touched.electricityPricingModel &&
                                props.errors.electricityPricingModel && (
                                  <p className="text-danger">
                                    {props.errors.electricityPricingModel}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Electricity Usage
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="electricityUsage">
                                <option value="">Select</option>
                                <option value="hydroponicsOnly">
                                  Hydroponics Only
                                </option>
                                <option value="sharedWithFactory">
                                  Shared with Factory
                                </option>
                                <option value="sharedWithHome">
                                  Shared with Home
                                </option>
                                <option value="sharedWithFarming">
                                  Shared with Farming
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select how electricity is used at the site, such as Hydroponics Only, Shared with Factory, Shared with Home, etc."
                              }
                            /> */}
                              {props.touched.electricityUsage &&
                                props.errors.electricityUsage && (
                                  <p className="text-danger">
                                    {props.errors.electricityUsage}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Internet Connectivity
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect name="internetConnectivity">
                                <option value="">Select</option>
                                <option value="noInternet">No Internet</option>
                                <option value="broadband">Broadband</option>
                                <option value="portableHotspot">
                                  Portable Hotspot
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the type of internet connectivity available at the site, such as No Internet, Broadband, or Portable Hotspot."
                              }
                            /> */}
                              {props.touched.internetConnectivity &&
                                props.errors.internetConnectivity && (
                                  <p className="text-danger">
                                    {props.errors.internetConnectivity}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {step === 13 && (
                    <>
                      <h2 className="m-0 p-2">Financial Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Financial Details:</h3>
                              This will be used to create the Detailed project
                              report and mainly calculate the ROI.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Average Labour Salary (Monthly)
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="averageLabourSalary"
                                type="text"
                              />
                              {/* <DynamicTooltip
                              label={
                                "Enter the average monthly salary paid to laborers working at the site."
                              }
                            /> */}
                              {props.touched.averageLabourSalary &&
                                props.errors.averageLabourSalary && (
                                  <p className="text-danger">
                                    {props.errors.averageLabourSalary}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Land Monthly Lease Amount
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="monthlyLeasedAmount"
                                type="text"
                              />
                              {/* <DynamicTooltip
                              label={
                                "Enter the monthly lease amount paid for the land at the site."
                              }
                            /> */}
                              {props.touched.monthlyLeasedAmount &&
                                props.errors.monthlyLeasedAmount && (
                                  <p className="text-danger">
                                    {props.errors.monthlyLeasedAmount}
                                  </p>
                                )}
                            </div>
                          </div>

                          {role !== process.env.REACT_APP_ROLE_CLIENT && (
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3  ">
                                Quotation
                              </label>

                              <div className="col-lg-9 dropdown position-relative">
                                <CustomInput
                                  type={"text"}
                                  className="form-control"
                                  onChange={(e) => {
                                    props.setFieldValue(
                                      "quotationNumber",
                                      e.target.value
                                    );
                                    handleInputChange(e, props);
                                  }}
                                  name="quotationNumber"
                                ></CustomInput>
                                {/* <DynamicTooltip
                                label={
                                  "Select or enter the quotation number associated with the site."
                                }
                              /> */}
                                {isDropdown && (
                                  <span
                                    onClick={() => {
                                      if (
                                        isDropdown !== "Quotations Not Found" &&
                                        isDropdown !== ""
                                      ) {
                                        props.setFieldValue(
                                          "quotationNumber",
                                          isDropdown
                                        );
                                        setIsDropdown("");
                                      }
                                    }}
                                    className="card cursor-pointer"
                                  >
                                    {isDropdown}
                                  </span>
                                )}
                              </div>
                            </div>
                          )}

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Project Funding Plan
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                type="text"
                                name="projectFundingPlan"
                              >
                                <option value="">select </option>
                                <option value="personalFunding">
                                  Personal Funding
                                </option>
                                <option value="equityFunding">
                                  Equity Funding
                                </option>
                                <option value="agricultureFunding">
                                  Agriculture Funding
                                </option>
                                <option value="personalLoan">
                                  Personal Loan
                                </option>
                                <option value="partnerFunding">
                                  Partner Funding
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                '"Select the funding plan for the project at the site, such as Personal Funding, Equity Funding, Agriculture Funding, etc."'
                              }
                            /> */}
                              {props.touched.projectFundingPlan &&
                                props.errors.projectFundingPlan && (
                                  <p className="text-danger">
                                    {props.errors.projectFundingPlan}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3 col">
                              Looking For Government Support
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="lookingForGovernmentSupport"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether you are looking for government support for the project at the site."
                              }
                            /> */}
                              {props.touched.lookingForGovernmentSupport &&
                                props.errors.lookingForGovernmentSupport && (
                                  <p className="text-danger">
                                    {props.errors.lookingForGovernmentSupport}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className=" form-label col-lg-3 col">
                              Looking for Loan
                            </label>
                            <div className="ps-2 col-lg-9 col-3 position-relative">
                              <CustomCheckbox
                                name="lookingForLoan"
                                type="checkbox"
                                width={"17px"}
                                height={"17px"}
                              />
                              {/* <DynamicTooltip
                              label={
                                "Indicate whether you are looking for a loan to fund the project at the site."
                              }
                            /> */}
                              {props.touched.lookingForLoan &&
                                props.errors.lookingForLoan && (
                                  <p className="text-danger">
                                    {props.errors.lookingForLoan}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Select Primary Loan Bank
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect type="text" name="primaryLoanBank">
                                <option value="">select </option>
                                {bankInfo?.map((el) => {
                                  return (
                                    <option key={el.number}>{el?.Name}</option>
                                  );
                                })}
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the primary loan bank for financing the project at the site."
                              }
                            /> */}
                              {props.touched.primaryLoanBank &&
                                props.errors.primaryLoanBank && (
                                  <p className="text-danger">
                                    {props.errors.primaryLoanBank}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Primary Loan Bank IFSC
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput name="primaryLoanIfsc" type="text" />
                              {/* <DynamicTooltip
                              label={
                                "Enter the IFSC code of the primary loan bank selected for financing the project at the site."
                              }
                            /> */}
                              {props.touched.primaryLoanIfsc &&
                                props.errors.primaryLoanIfsc && (
                                  <p className="text-danger">
                                    {props.errors.primaryLoanIfsc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Select Secondary Loan Bank
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                type="text"
                                name="secondaryLoanBank"
                              >
                                <option value="">select </option>
                                {bankInfo?.map((el) => {
                                  return (
                                    <option key={el.number}>{el?.Name}</option>
                                  );
                                })}
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select the secondary loan bank for financing the project at the site."
                              }
                            /> */}
                              {props.touched.secondaryLoanBank &&
                                props.errors.secondaryLoanBank && (
                                  <p className="text-danger">
                                    {props.errors.secondaryLoanBank}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Secondary Loan Bank IFSC
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                name="secondaryLoanIfsc"
                                type="text"
                              />
                              {/* <DynamicTooltip
                              label={
                                "Enter the IFSC code of the secondary loan bank selected for financing the project at the site."
                              }
                            /> */}
                              {props.touched.secondaryLoanIfsc &&
                                props.errors.secondaryLoanIfsc && (
                                  <p className="text-danger">
                                    {props.errors.secondaryLoanIfsc}
                                  </p>
                                )}
                            </div>
                          </div>

                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Future expectation from plan
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomSelect
                                type="text"
                                name="futureExpectationFromPlan"
                              >
                                <option value="">select </option>
                                <option value="Retirement">Retirement</option>
                                <option value="Expansion">Expansion</option>
                                <option value="Build supply chain">
                                  Build supply chain
                                </option>
                                <option value="Research and development">
                                  Research and development
                                </option>
                                <option value="Specific plant growing">
                                  Specific plant growing
                                </option>
                              </CustomSelect>
                              {/* <DynamicTooltip
                              label={
                                "Select your future expectations from the project funding plan, such as Retirement, Expansion, Build supply chain, etc."
                              }
                            /> */}

                              {props.touched.futureExpectationFromPlan &&
                                props.errors.futureExpectationFromPlan && (
                                  <p className="text-danger">
                                    {props.errors.futureExpectationFromPlan}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 14 && (
                    <>
                      <h2 className="m-0 p-2">Additional Details</h2>
                      <hr className="my-1" />
                      <div className="row p-4">
                        <div className="col-12 col-md-3 col-lg-3 card">
                          <div className="p-2">
                            <p>
                              <h3>Additional Details:</h3>
                              If there is anything, we havent collected, and you
                              want to include or bring it to our attention.
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">
                              Description video
                            </label>
                            <div className="col-lg-9 position-relative">
                              <CustomInput
                                type={"file"}
                                name="descriptionVideo"
                                onChange={(e) =>
                                  props.setFieldValue(
                                    "descriptionVideo",
                                    e.target.files[0]
                                  )
                                }
                              />
                              {/* <DynamicTooltip
                              label={
                                "Upload a video that provides a description of the site."
                              }
                            /> */}
                              {props.touched.descriptionVideo &&
                                props.errors.descriptionVideo && (
                                  <p className="text-danger">
                                    {props.errors.descriptionVideo}
                                  </p>
                                )}
                            </div>
                          </div>
                          <div className="mb-3 row">
                            <label className="form-label col-lg-3">Notes</label>
                            <div className="col-lg-9 position-relative">
                              <CustomTextArea name="notes" type="textarea">
                                <option value="">select</option>
                              </CustomTextArea>
                              {/* <DynamicTooltip
                              label={
                                "Provide any additional notes or comments regarding the site."
                              }
                            /> */}
                              {props.touched.notes && props.errors.notes && (
                                <p className="text-danger">
                                  {props.errors.notes}
                                </p>
                              )}
                            </div>
                          </div>

                          {role !== process.env.REACT_APP_ROLE_CLIENT && (
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3 col">
                                Mark site not feasible
                              </label>
                              <div className="ps-2 col-lg-9 col-3 position-relative">
                                <CustomCheckbox
                                  name="markSiteNotFeasible"
                                  type="checkbox"
                                  width={"17px"}
                                  height={"17px"}
                                />
                                {/* <DynamicTooltip
                                label={
                                  "Check this box if the site is deemed not feasible for the intended project."
                                }
                              /> */}
                                {props.touched.markSiteNotFeasible &&
                                  props.errors.markSiteNotFeasible && (
                                    <p className="text-danger">
                                      {props.errors.markSiteNotFeasible}
                                    </p>
                                  )}
                              </div>
                            </div>
                          )}
                          {role !== process.env.REACT_APP_ROLE_CLIENT &&
                            props.values.markSiteNotFeasible && (
                              <div className="mb-3 row">
                                <label className="form-label col-lg-3">
                                  Reason of non feasibility
                                </label>
                                <div className="col-lg-9 position-relative">
                                  <CustomTextArea
                                    name="reasonOfNonFeasibility"
                                    type="textarea"
                                  />
                                  {/* <DynamicTooltip
                                  label={
                                    "Provide the reason why the site is considered not feasible."
                                  }
                                /> */}
                                  {props.touched.reasonOfNonFeasibility &&
                                    props.errors.reasonOfNonFeasibility && (
                                      <p className="text-danger">
                                        {props.errors.reasonOfNonFeasibility}
                                      </p>
                                    )}
                                </div>
                              </div>
                            )}
                        </div>
                      </div>
                    </>
                  )}

                  {step === 15 &&
                    role !== process.env.REACT_APP_ROLE_CLIENT && (
                      <>
                        <h2 className="m-0 p-2">AIF Details</h2>
                        <hr className="my-1" />
                        <div className="row p-4">
                          <div className="col-12 col-md-3 col-lg-3 card">
                            <div className="p-2">
                              <p>
                                <h3>AIF Details:</h3>
                                These details will be used to make an Agri
                                Infrastructure Fund application for you. and
                                include those details in the DPR.
                              </p>
                            </div>
                          </div>
                          <div className="col-12 col-md-8 col-lg-8 ms-0 ms-md-2 ms-lg-2 card p-3">
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Applied for AIF DPR
                              </label>
                              <div className="ps-2 col-lg-9 col-3 position-relative">
                                <CustomCheckbox
                                  name="appliedForAIFDPR"
                                  type="checkbox"
                                  width={"17px"}
                                  height={"17px"}
                                />
                                {/* <DynamicTooltip
                                label={
                                  "Check this box if you have applied for the AIF DPR."
                                }
                              /> */}
                                {props.touched.appliedForAIFDPR &&
                                  props.errors.appliedForAIFDPR && (
                                    <p className="text-danger">
                                      {props.errors.appliedForAIFDPR}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3  ">
                                AIF Quotation
                              </label>

                              <div className="col-lg-9 dropdown">
                                <CustomInput
                                  type={"text"}
                                  className="form-control"
                                  onChange={(e) => {
                                    props.setFieldValue(
                                      "aifQuotationNumber",
                                      e.target.value
                                    );
                                    handleInputChange(e, props);
                                  }}
                                  name="aifQuotationNumber"
                                ></CustomInput>
                                {/* <DynamicTooltip
                                label={
                                  "Select or enter the AIF quotation number associated with the site. this is required if you have applied for the AIF DPR. All aif calculations will be based on this quotation."
                                }
                              /> */}
                                {props.touched.aifQuotationNumber &&
                                  props.errors.aifQuotationNumber && (
                                    <p className="text-danger">
                                      {props.errors.aifQuotationNumber}
                                    </p>
                                  )}
                                {isDropdown && (
                                  <span
                                    onClick={() => {
                                      if (
                                        isDropdown !== "Quotations Not Found" &&
                                        isDropdown !== ""
                                      ) {
                                        props.setFieldValue(
                                          "aifQuotationNumber",
                                          isDropdown
                                        );
                                        setIsDropdown("");
                                      }
                                    }}
                                    className="card cursor-pointer"
                                  >
                                    {isDropdown}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Borrow From The Bank (%)
                              </label>
                              <div className="col-lg-9 position-relative">
                                <CustomInput
                                  type="text"
                                  name="borrowFromBank"
                                />
                                {/* <DynamicTooltip
                                label={
                                  "Enter the percentage of funding you plan to borrow from the bank for the project at the site. this is required if you have applied for the AIF DPR."
                                }
                              /> */}
                                {props.touched.borrowFromBank &&
                                  props.errors.borrowFromBank && (
                                    <p className="text-danger">
                                      {props.errors.borrowFromBank}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Tenure (in years)
                              </label>
                              <div className="col-lg-9 position-relative">
                                <CustomInput
                                  type="text"
                                  name="tenure"
                                  disabled
                                />
                                {/* <DynamicTooltip
                                label={
                                  "Enter the tenure in years for the loan you plan to take from the bank for the project at the site. this is required if you have applied for the AIF DPR."
                                }
                              /> */}
                                {props.touched.tenure &&
                                  props.errors.tenure && (
                                    <p className="text-danger">
                                      {props.errors.tenure}
                                    </p>
                                  )}
                              </div>
                            </div>

                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Rate of Interest (%)
                              </label>
                              <div className="col-lg-9 position-relative">
                                <CustomInput type="text" name="rateOfInt" />
                                {/* <DynamicTooltip
                                label={
                                  "Enter the rate of interest percentage for the loan you plan to take from the bank for the project at the site. this is required if you have applied for the AIF DPR."
                                }
                              /> */}
                                {props.touched.rateOfInt &&
                                  props.errors.rateOfInt && (
                                    <p className="text-danger">
                                      {props.errors.rateOfInt}
                                    </p>
                                  )}
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <label className="form-label col-lg-3">
                                Funding amount type
                              </label>
                              <div className="col-lg-9 position-relative">
                                <CustomSelect
                                  type="text"
                                  name="fundingAmmountType"
                                >
                                  <option value="">Select</option>
                                  <option value="preGST">Pre GST</option>
                                  <option value="postGST">Post GST</option>
                                </CustomSelect>
                                {/* <DynamicTooltip
                                label={
                                  "Select the type of funding amount, either Pre GST or Post GST, for the project at the site."
                                }
                              /> */}
                                {props.touched.fundingAmmountType &&
                                  props.errors.fundingAmmountType && (
                                    <p className="text-danger">
                                      {props.errors.fundingAmmountType}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </div>{" "}
                        </div>
                      </>
                    )}

                  <div className="card-footer mt-4">
                    <div className="btn-list justify-content-end">
                      {step > 0 && (
                        <SimpleButton
                          buttonText="Previous"
                          onClick={prevStep}
                        />
                      )}
                      {(role === process.env.REACT_APP_ROLE_CLIENT
                        ? step < SiteInspectionSchema?.length - 2
                        : step < SiteInspectionSchema.length - 1) && (
                        <SimpleButton buttonText="Next" onClick={nextStep} />
                      )}
                      {(
                        role === process.env.REACT_APP_ROLE_CLIENT
                          ? step < SiteInspectionSchema.length - 2
                          : step < SiteInspectionSchema.length - 1
                      ) ? (
                        <>
                          <FormSubmitButton buttonText="Save & Next" />
                          <a
                            className="btn mx-1 mt-2 btn-primary text-uppercase"
                            onClick={() => handelSubmit(props.values, "exit")}
                          >
                            <BsBoxArrowInRight className="fs-2 me-2" />
                            Save & Exit
                          </a>
                        </>
                      ) : (
                        <FormSubmitButton buttonText="Submit" />
                      )}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};
export default EditClientSiteInspection;
